import { useEffect, } from 'react';
import { Routes, Route, Navigate, useLocation, } from 'react-router-dom';
import { auth, } from './firebase/config';
import { onAuthStateChanged, } from 'firebase/auth';
import { useApp, useAuth, } from './hooks';
import { RequireAuth, } from './hoc/RequireAuth';
import { CssBaseline, } from '@mui/material';
import Layout from './components/layout';
import {
    LandingPage,
    LatestPage,
    SignupPage,
    LoginPage,
    HelpPage,
    AboutPage,
    FoldersPage,
    SetPage,
    SetsPage,
    CreateSetPage,
    EditSetPage,
    FolderPage,
    EditFolderPage,
    LearningCardsPage,
    WriteCardsPage,
    TermsAndConditionsPage,
    ConfidentialityPage,
    NotfoundPage, } from './pages';
import NewFolderModal from './components/new-folder-modal';

function App() {
    const { authUser, } = useApp();
    const { authIsReady, user, } = useAuth();
    const { pathname, } = useLocation();

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, (user) => {
            authUser(user);
            unsub();
        })
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

  return (
      <>
        <CssBaseline />
          {
              authIsReady && (
                  <Routes>
                      <Route path='/' element={<Layout />}>
                          <Route index element={user ? <Navigate to='latest' replace /> : <LandingPage />} />

                          <Route path='latest' element={
                              <RequireAuth>
                                  <LatestPage />
                              </RequireAuth>
                          } />

                          <Route path='set/:id' element={
                              <RequireAuth>
                                  <SetPage />
                              </RequireAuth>
                          } />

                          <Route path='set/create' element={
                              <RequireAuth>
                                  <CreateSetPage />
                              </RequireAuth>
                          } />

                          <Route path='set/edit/:id' element={
                              <RequireAuth>
                                  <EditSetPage />
                              </RequireAuth>
                          } />

                          <Route path='set/:id/learning-cards' element={
                              <RequireAuth>
                                  <LearningCardsPage />
                              </RequireAuth>
                          } />

                          <Route path='set/:id/write-cards' element={
                              <RequireAuth>
                                  <WriteCardsPage />
                              </RequireAuth>
                          } />

                          <Route path='sets' element={
                              <RequireAuth>
                                  <SetsPage />
                              </RequireAuth>
                          } />

                          <Route path='folder/:id' element={
                              <RequireAuth>
                                  <FolderPage />
                              </RequireAuth>
                          } />

                          <Route path='folder/edit/:id' element={
                              <RequireAuth>
                                  <EditFolderPage />
                              </RequireAuth>
                          } />

                          <Route path='folders' element={
                              <RequireAuth>
                                  <FoldersPage />
                              </RequireAuth>
                          } />

                          <Route path='signup' element={user ? <Navigate to='/latest' replace /> : <SignupPage />} />
                          <Route path='login' element={user ? <Navigate to='/latest' replace /> : <LoginPage />} />
                          <Route path='help' element={<HelpPage />} />
                          <Route path='about' element={<AboutPage />} />
                          <Route path='terms' element={<TermsAndConditionsPage />} />
                          <Route path='confidentiality' element={<ConfidentialityPage />} />
                          <Route path='*' element={<NotfoundPage />} />
                      </Route>
                  </Routes>
              )
          }
          { user && <NewFolderModal /> }
      </>
  );
}

export default App;